import { Link } from 'react-router-dom';
import { Store, DollarSign, Calendar, Users, CheckCircle, Mail } from 'lucide-react';

const PopUpProgram = () => {
  return (
    <div className="bg-off_white" data-testid="popup-program-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-brand_yellow to-brand_green py-20 border-b-4 border-black relative overflow-hidden">
        {/* Decorative Stars */}
        <div className="absolute top-16 right-16 w-10 h-10">
          <div className="w-full h-full bg-white/80 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)' }} />
        </div>
        <div className="absolute bottom-20 left-20 w-8 h-8">
          <div className="w-full h-full bg-brand_blue/70 rotate-45" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute top-1/3 left-1/3 w-7 h-7">
          <div className="w-full h-full bg-brand_red/60 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '8s' }} />
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h1 className="font-chewy text-5xl sm:text-7xl text-black drop-shadow-[2px_2px_0px_rgba(255,255,255,1)] mb-6">
            POP-UP STAND PROGRAM
          </h1>
          <p className="font-nunito text-2xl text-black font-bold">
            Empower Your Family Through Entrepreneurship
          </p>
        </div>
      </section>

      {/* Overview */}
      <section className="py-16 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 border-b-4 border-black relative overflow-hidden">
        {/* More Stars */}
        <div className="absolute top-12 left-16 w-10 h-10">
          <div className="w-full h-full bg-blue-400/70 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '2.5s' }} />
        </div>
        <div className="absolute top-20 right-20 w-8 h-8">
          <div className="w-full h-full bg-indigo-400/60 rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute bottom-20 left-24 w-9 h-9">
          <div className="w-full h-full bg-purple-400/80 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '9s' }} />
        </div>
        <div className="absolute bottom-32 right-24 w-7 h-7">
          <div className="w-full h-full bg-blue-300/70 rotate-45 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)', animationDuration: '3s' }} />
        </div>
        <div className="absolute top-1/3 left-1/4 w-6 h-6">
          <div className="w-full h-full bg-indigo-500/60 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '15s' }} />
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="bg-brand_blue/10 border-4 border-black rounded-2xl p-8 shadow-hard mb-12">
            <h2 className="font-chewy text-4xl text-brand_blue text-center mb-6">
              WHAT IS THE POP-UP PROGRAM?
            </h2>
            <p className="font-nunito text-lg text-center leading-relaxed">
              Uncle Dave's Pop-Up Stand Program is designed to help single and non-working parent households 
              learn entrepreneurship and financial literacy. Rent a stand, receive juice supplies, and earn 
              a percentage of your sales while building valuable business skills with your family!
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            <div className="bg-gradient-to-br from-purple-400 via-pink-400 to-orange-400 border-4 border-black rounded-xl p-8 shadow-hard-lg relative overflow-hidden flex items-center justify-center min-h-[300px]">
              {/* Decorative Stars and Dollar Signs */}
              <div className="absolute top-4 left-4 text-brand_yellow text-4xl animate-pulse">★</div>
              <div className="absolute top-6 right-8 text-brand_green text-5xl font-bold animate-bounce">$</div>
              <div className="absolute bottom-8 left-6 text-white text-3xl animate-spin" style={{ animationDuration: '3s' }}>★</div>
              <div className="absolute bottom-4 right-6 text-brand_blue text-4xl font-bold">$</div>
              <div className="absolute top-1/2 left-8 text-brand_red text-2xl">★</div>
              <div className="absolute top-1/3 right-12 text-brand_yellow text-3xl font-bold animate-pulse">$</div>
              <div className="absolute bottom-1/3 left-12 text-orange-300 text-3xl animate-bounce">★</div>
              <div className="absolute top-3/4 right-16 text-pink-300 text-2xl">★</div>
              <div className="absolute top-1/4 left-1/3 text-white text-xl">★</div>
              <div className="absolute bottom-1/4 right-1/4 text-brand_green text-2xl font-bold">$</div>
              
              {/* Main Text */}
              <div className="text-center relative z-10">
                <h3 className="font-chewy text-5xl sm:text-6xl lg:text-7xl leading-tight">
                  <span className="text-brand_yellow drop-shadow-[4px_4px_0px_rgba(0,0,0,1)]">YOU</span>{' '}
                  <span className="text-brand_red drop-shadow-[4px_4px_0px_rgba(0,0,0,1)]">HAVE</span>{' '}
                  <span className="text-brand_blue drop-shadow-[4px_4px_0px_rgba(0,0,0,1)]">TO</span>
                  <br />
                  <span className="text-brand_green drop-shadow-[4px_4px_0px_rgba(0,0,0,1)]">POP</span>{' '}
                  <span className="text-white drop-shadow-[4px_4px_0px_rgba(0,0,0,1)]">OUT</span>
                  <br />
                  <span className="text-brand_yellow drop-shadow-[4px_4px_0px_rgba(0,0,0,1)]">TO</span>{' '}
                  <span className="text-pink-300 drop-shadow-[4px_4px_0px_rgba(0,0,0,1)]">POP</span>{' '}
                  <span className="text-orange-300 drop-shadow-[4px_4px_0px_rgba(0,0,0,1)]">UP!</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-16 bg-gradient-to-br from-emerald-50 via-green-50 to-lime-50 relative overflow-hidden">
        {/* More Stars */}
        <div className="absolute top-16 right-12 w-10 h-10">
          <div className="w-full h-full bg-emerald-400/70 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '2s' }} />
        </div>
        <div className="absolute bottom-20 left-16 w-8 h-8">
          <div className="w-full h-full bg-green-400/60 rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute top-1/3 left-20 w-9 h-9">
          <div className="w-full h-full bg-lime-400/80 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '12s' }} />
        </div>
        <div className="absolute top-1/4 right-24 w-7 h-7">
          <div className="w-full h-full bg-emerald-300/70 rotate-45 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)', animationDuration: '2.5s' }} />
        </div>
        <div className="absolute bottom-1/4 right-1/3 w-6 h-6">
          <div className="w-full h-full bg-green-500/60 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '16s' }} />
        </div>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <h2 className="font-chewy text-4xl sm:text-6xl text-center mb-12">
            <span className="text-brand_blue">HOW IT</span>{' '}
            <span className="text-brand_red">WORKS</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                step: '1',
                title: 'Rent Your Stand',
                desc: 'Choose from daily, weekly, or monthly rental options that fit your schedule and budget'
              },
              {
                step: '2',
                title: 'Receive Supplies',
                desc: 'Get fresh Uncle Dave\'s lemonade and all materials needed to run your stand successfully'
              },
              {
                step: '3',
                title: 'Earn & Learn',
                desc: 'Keep a percentage of your sales while teaching your family valuable entrepreneurship skills'
              }
            ].map((item, idx) => (
              <div
                key={idx}
                className="bg-white border-4 border-black rounded-xl p-8 shadow-hard text-center"
              >
                <div className="bg-brand_yellow w-16 h-16 rounded-full border-4 border-black mx-auto mb-4 flex items-center justify-center">
                  <span className="font-chewy text-3xl">{item.step}</span>
                </div>
                <h3 className="font-chewy text-2xl text-brand_blue mb-3">
                  {item.title}
                </h3>
                <p className="font-nunito text-gray-700 font-semibold">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16 bg-white border-y-4 border-black">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-chewy text-4xl sm:text-6xl text-center mb-12">
            <span className="text-brand_blue">PROGRAM</span>{' '}
            <span className="text-brand_red">BENEFITS</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              {
                icon: DollarSign,
                title: 'Earn Income',
                desc: 'Keep a percentage of your sales and build financial independence'
              },
              {
                icon: Users,
                title: 'Family Bonding',
                desc: 'Work together with your children and create lasting memories'
              },
              {
                icon: Store,
                title: 'Business Skills',
                desc: 'Learn customer service, money management, and sales techniques'
              },
              {
                icon: Calendar,
                title: 'Flexible Schedule',
                desc: 'Choose rental periods that work for your family\'s lifestyle'
              },
              {
                icon: CheckCircle,
                title: 'Full Support',
                desc: 'Get training, materials, and ongoing assistance from Uncle Dave\'s team'
              },
              {
                icon: Users,
                title: 'Community Network',
                desc: 'Connect with other families and build relationships in your area'
              }
            ].map((benefit, idx) => (
              <div
                key={idx}
                className="bg-off_white border-4 border-black rounded-xl p-6 shadow-hard flex items-start gap-4"
              >
                <div className="bg-brand_blue w-14 h-14 rounded-full border-3 border-black flex items-center justify-center flex-shrink-0">
                  <benefit.icon className="w-7 h-7 text-white" strokeWidth={3} />
                </div>
                <div>
                  <h3 className="font-chewy text-xl text-brand_blue mb-2">
                    {benefit.title}
                  </h3>
                  <p className="font-nunito text-gray-700 font-semibold">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="py-16 bg-gradient-to-br from-amber-100 via-orange-100 to-red-100 relative overflow-hidden">
        {/* More Stars */}
        <div className="absolute top-12 left-20 w-10 h-10">
          <div className="w-full h-full bg-amber-400/70 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '2.5s' }} />
        </div>
        <div className="absolute top-24 right-16 w-8 h-8">
          <div className="w-full h-full bg-orange-400/60 rotate-12" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)' }} />
        </div>
        <div className="absolute bottom-16 left-24 w-9 h-9">
          <div className="w-full h-full bg-red-400/80 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '10s' }} />
        </div>
        <div className="absolute bottom-32 right-20 w-7 h-7">
          <div className="w-full h-full bg-amber-300/70 rotate-45 animate-pulse" style={{ clipPath: 'polygon(50% 0%, 65% 40%, 100% 50%, 65% 60%, 50% 100%, 35% 60%, 0% 50%, 35% 40%)', animationDuration: '3s' }} />
        </div>
        <div className="absolute top-1/2 left-1/3 w-6 h-6">
          <div className="w-full h-full bg-orange-500/60 animate-spin" style={{ clipPath: 'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)', animationDuration: '14s' }} />
        </div>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <h2 className="font-chewy text-4xl sm:text-6xl text-center mb-12">
            <span className="text-brand_blue">RENTAL</span>{' '}
            <span className="text-brand_red">OPTIONS</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: 'Daily',
                desc: 'Perfect for testing the waters',
                features: [
                  '1 day stand rental',
                  'Juice supply for the day',
                  'All materials included',
                  'Keep 40% of sales'
                ]
              },
              {
                name: 'Weekly',
                desc: 'Most popular option',
                features: [
                  '7 day stand rental',
                  'Weekly juice restocks',
                  'Marketing materials',
                  'Keep 50% of sales',
                  'Training session'
                ],
                popular: true
              },
              {
                name: 'Monthly',
                desc: 'Best value for committed families',
                features: [
                  '30 day stand rental',
                  'Weekly juice deliveries',
                  'Premium location support',
                  'Keep 60% of sales',
                  'Ongoing mentorship'
                ]
              }
            ].map((plan, idx) => (
              <div
                key={idx}
                className={`bg-white border-4 border-black rounded-2xl p-8 shadow-hard hover:shadow-hard-lg hover:-translate-y-2 transition-all ${
                  plan.popular ? 'ring-4 ring-brand_yellow' : ''
                }`}
              >
                {plan.popular && (
                  <div className="bg-brand_yellow text-black font-chewy text-sm px-4 py-1 rounded-full border-2 border-black inline-block mb-4">
                    MOST POPULAR
                  </div>
                )}
                <h3 className="font-chewy text-3xl text-brand_blue mb-2">
                  {plan.name}
                </h3>
                <p className="font-nunito text-gray-600 font-semibold mb-6">
                  {plan.desc}
                </p>
                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="font-nunito font-semibold flex items-start gap-2">
                      <CheckCircle className="w-5 h-5 text-brand_green flex-shrink-0 mt-0.5" strokeWidth={3} />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  className="block w-full bg-brand_blue text-white text-center font-chewy text-lg px-6 py-3 rounded-full border-2 border-black shadow-hard hover:shadow-hard-hover hover:-translate-y-0.5 transition-all"
                >
                  Get Started
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact" className="py-16 bg-white border-t-4 border-black">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-off_white border-4 border-black rounded-2xl p-8 shadow-hard">
            <div className="text-center mb-8">
              <div className="bg-brand_yellow w-20 h-20 rounded-full border-4 border-black mx-auto mb-4 flex items-center justify-center">
                <Mail className="w-10 h-10" strokeWidth={3} />
              </div>
              <h2 className="font-chewy text-4xl text-brand_blue mb-2">
                INTERESTED IN STARTING?
              </h2>
              <p className="font-nunito text-lg font-semibold">
                Fill out the form below and we'll get back to you within 24 hours!
              </p>
            </div>

            <form className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="font-nunito font-bold block mb-2">Your Name</label>
                  <input
                    type="text"
                    required
                    className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                    placeholder="John Doe"
                  />
                </div>
                <div>
                  <label className="font-nunito font-bold block mb-2">Phone</label>
                  <input
                    type="tel"
                    required
                    className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                    placeholder="(555) 123-4567"
                  />
                </div>
              </div>

              <div>
                <label className="font-nunito font-bold block mb-2">Email</label>
                <input
                  type="email"
                  required
                  className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                  placeholder="your@email.com"
                />
              </div>

              <div>
                <label className="font-nunito font-bold block mb-2">Rental Period</label>
                <select
                  className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                  required
                >
                  <option value="">Select an option</option>
                  <option value="daily">Daily</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                </select>
              </div>

              <div>
                <label className="font-nunito font-bold block mb-2">Tell us about your family</label>
                <textarea
                  rows="4"
                  className="w-full px-4 py-3 border-2 border-black rounded-lg font-nunito focus:ring-2 focus:ring-brand_blue focus:ring-offset-2"
                  placeholder="Tell us about yourself and why you're interested in the program..."
                  required
                />
              </div>

              <button
                type="submit"
                className="w-full bg-brand_blue text-white font-chewy text-xl px-8 py-4 rounded-full border-4 border-black shadow-hard-lg hover:shadow-hard-hover hover:-translate-y-1 transition-all"
              >
                SUBMIT APPLICATION
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PopUpProgram;